if (!document.getElementById("employer-create-job")) return;

document.addEventListener("DOMContentLoaded", function() {
	const jobCharge   = document.getElementById("job-charge").value;
	const startDateInput = document.getElementById("start-date");
	const endDateInput   = document.getElementById("end-date");
	let startDate = '', endDate = '';

	if( startDateInput && endDateInput ) {
		startDateInput.addEventListener("change", function() {
			startDate = this.value;
			endDate = endDateInput.value;
			yakklyJobCharge(startDate, endDate, jobCharge);
		});
		
		endDateInput.addEventListener("change", function() {
			startDate = startDateInput.value;
			endDate = this.value;

			yakklyJobCharge(startDate, endDate, jobCharge);
		});
		
		
	}

	function yakklyJobCharge(startDate, endDate, jobCharge) {
        console.log( startDate );
		console.log( endDate );
        console.log( jobCharge );
        console.log( '------' );
		if (!startDate) return;
		if (!endDate) return;
		if (!jobCharge) return;
        
		let currency = document.getElementById("charge-currency");
		if (!currency) return;

		let oldTotal = document.querySelector(".job-charge-total");
		if (oldTotal) oldTotal.remove();

		let startDay = new Date(startDate);
		let endDay   = new Date(endDate);

		let today = new Date();
		today.setHours(0,0,0,0);
		startDay.setHours(0,0,0,0);
		endDay.setHours(0,0,0,0);

		if (startDay < today) {
			// alert("Start date must be today or in the future.");
			return;
		}
		if (endDay <= startDay) {
			// alert("End date must be later than start date.");
			return;
		}

		let diffTime = endDay - startDay;
		let diffDays = diffTime / (1000 * 60 * 60 * 24);

		let weeks = Math.ceil(diffDays / 7);
		let total = weeks * jobCharge;

		if( weeks == 4 ) {
			total = 3 * jobCharge;
		}

		let chargeEl = document.createElement("div");
		chargeEl.classList.add("job-charge-total");
		chargeEl.innerHTML = `<b>Total charge is ${currency.value}${total}</b>`;

		let jobWeek = document.getElementById("job-week");
		jobWeek.value = weeks;
		if (jobWeek.nextSibling) {
			jobWeek.parentNode.insertBefore(chargeEl, jobWeek.nextSibling);
		} else {
			jobWeek.parentNode.appendChild(chargeEl);
		}
	}
	
});